<div class="error-box">
    <div class="error-body text-center">
        <h1 class="error-title text-danger">404</h1>
        <h3 class="text-uppercase error-subtitle">PÁGINA NO ENCONTRADA !</h3>
        <p class="text-muted m-t-30 m-b-30">PARECE QUE ESTÁS PERDIDO EN EL ESPACIO</p>
        <a (click)="backClicked()" class="btn btn-danger btn-rounded waves-effect waves-light m-b-40">
            Regresar</a>
    </div>
</div>